import Component, { mixins } from 'vue-class-component';

import { AxiosError, AxiosResponse } from "axios";

import { STORE_ACTIONS } from '@/store';

import { ICity } from './ICity.model';

import BaseService from '../../base/Base.service';

@Component
export default class CityService extends mixins(BaseService) {
  protected service_cityService_fetchCities(): Promise<Array<ICity>> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.get(`/api/inscriptions-lieu-examen/villes`)
        .then((response: AxiosResponse) => {
          const cities: Array<any> = response.data.data.villes

          this.$store.dispatch(STORE_ACTIONS.CITY_STORE_CITIES, cities)

          resolve(cities)
        }).catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
    })
  }
}